/* ===========================================================
   Myoform — Pricing Offer V2
   Image hotspots: open on click / Enter / Space (and on hover for
   fine pointers), close on Escape or an outside tap, and flip or
   shift the popover so it always stays inside the viewport.
   =========================================================== */

(function () {
  var EDGE = 12;
  var sections = [];

  function Hotspot(el) {
    this.el = el;
    this.button = el.querySelector('[data-mpo-dot]');
    this.pop = el.querySelector('[data-mpo-pop]');
    this.open = false;
    this.pinned = false;
  }

  Hotspot.prototype.place = function () {
    // Measure in the default (below, unshifted) position first, then correct.
    this.pop.style.setProperty('--mpo-shift', '0px');
    this.el.classList.remove('is-above');

    var rect = this.pop.getBoundingClientRect();
    var viewportWidth = document.documentElement.clientWidth;
    var viewportHeight = document.documentElement.clientHeight;

    var shift = 0;
    if (rect.left < EDGE) {
      shift = EDGE - rect.left;
    } else if (rect.right > viewportWidth - EDGE) {
      shift = viewportWidth - EDGE - rect.right;
    }
    if (shift) {
      this.pop.style.setProperty('--mpo-shift', Math.round(shift) + 'px');
    }

    var overflowsBelow = rect.bottom > viewportHeight - EDGE;
    var fitsAbove = rect.top - rect.height - 52 > EDGE;
    if (overflowsBelow && fitsAbove) {
      this.el.classList.add('is-above');
    }
  };

  Hotspot.prototype.show = function (pinned) {
    this.pinned = this.pinned || !!pinned;
    if (this.open) {
      this.place();
      return;
    }
    // Measured while still hidden: the popover already has a layout box, so it
    // can be flipped and clamped before it fades in rather than sliding after.
    this.place();
    this.open = true;
    this.el.classList.add('is-open');
    this.button.setAttribute('aria-expanded', 'true');
  };

  Hotspot.prototype.hide = function () {
    if (!this.open) return;
    this.open = false;
    this.pinned = false;
    this.el.classList.remove('is-open', 'is-above');
    this.button.setAttribute('aria-expanded', 'false');
  };

  function initSection(root) {
    if (root.dataset.mpoReady === 'true') return null;
    root.dataset.mpoReady = 'true';

    var hotspots = [];
    var nodes = root.querySelectorAll('[data-mpo-hotspot]');
    if (!nodes.length) return null;

    var canHover =
      window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function closeAll(except) {
      for (var i = 0; i < hotspots.length; i++) {
        if (hotspots[i] !== except) hotspots[i].hide();
      }
    }

    for (var i = 0; i < nodes.length; i++) {
      (function (node) {
        var hotspot = new Hotspot(node);
        if (!hotspot.button || !hotspot.pop) return;
        hotspots.push(hotspot);

        hotspot.button.addEventListener('click', function () {
          if (hotspot.open && hotspot.pinned) {
            hotspot.hide();
          } else {
            closeAll(hotspot);
            hotspot.show(true);
          }
        });

        hotspot.button.addEventListener('focus', function () {
          closeAll(hotspot);
          hotspot.show(false);
        });

        hotspot.button.addEventListener('blur', function () {
          if (!hotspot.pinned) hotspot.hide();
        });

        if (canHover) {
          node.addEventListener('mouseenter', function () {
            closeAll(hotspot);
            hotspot.show(false);
          });

          node.addEventListener('mouseleave', function () {
            if (!hotspot.pinned) hotspot.hide();
          });
        }
      })(nodes[i]);
    }

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      var wasOpen = null;
      for (var i = 0; i < hotspots.length; i++) {
        if (hotspots[i].open) wasOpen = hotspots[i];
      }
      if (!wasOpen) return;
      event.stopPropagation();
      wasOpen.hide();
      wasOpen.button.focus();
    });

    var api = {
      root: root,
      hotspots: hotspots,
      closeAll: closeAll,
      reposition: function () {
        for (var i = 0; i < hotspots.length; i++) {
          if (hotspots[i].open) hotspots[i].place();
        }
      }
    };
    sections.push(api);
    return api;
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-mpo]');
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  document.addEventListener('pointerdown', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-mpo-hotspot]')) return;
    for (var i = 0; i < sections.length; i++) sections[i].closeAll(null);
  });

  var repositionTimer = null;
  function scheduleReposition() {
    if (repositionTimer) return;
    repositionTimer = window.requestAnimationFrame(function () {
      repositionTimer = null;
      for (var i = 0; i < sections.length; i++) sections[i].reposition();
    });
  }

  window.addEventListener('resize', scheduleReposition);
  window.addEventListener('scroll', scheduleReposition, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor: re-bind on section reload and reveal the selected hotspot. */
  document.addEventListener('shopify:section:load', function (event) {
    sections = sections.filter(function (item) {
      return document.body.contains(item.root);
    });
    var root = event.target.querySelector('[data-mpo]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var node = event.target.closest
      ? event.target.closest('[data-mpo-hotspot]')
      : null;
    if (!node) node = event.target.querySelector('[data-mpo-hotspot]');
    if (!node) return;
    for (var i = 0; i < sections.length; i++) {
      for (var j = 0; j < sections[i].hotspots.length; j++) {
        var hotspot = sections[i].hotspots[j];
        if (hotspot.el === node) {
          sections[i].closeAll(hotspot);
          hotspot.show(true);
          return;
        }
      }
    }
  });

  document.addEventListener('shopify:block:deselect', function () {
    for (var i = 0; i < sections.length; i++) sections[i].closeAll(null);
  });
})();
